import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Container } from './design-system'
import { TestProvider } from './contexts/TestContext'
import { AuthProvider } from './contexts/AuthContext'

// Import pages (to be created in subsequent tasks)
import HomePage from './pages/HomePage'
import TestPage from './pages/TestPage'
import ResultsPage from './pages/ResultsPage'
import ProfilePage from './pages/ProfilePage'
import LeaderboardPage from './pages/LeaderboardPage'
import Navigation from './components/Navigation'

function App() {
  return (
    <AuthProvider>
      <TestProvider>
        <Router>
          <div className="min-h-screen bg-white">
            <Navigation />
            <Routes>
              <Route path="/" element={<Container adaptive><HomePage /></Container>} />
              <Route path="/test" element={<TestPage />} />
              <Route path="/results" element={<Container adaptive><ResultsPage /></Container>} />
              <Route path="/profile" element={<Container adaptive><ProfilePage /></Container>} />
              <Route path="/leaderboard" element={<Container adaptive><LeaderboardPage /></Container>} />
            </Routes>
          </div>
        </Router>
      </TestProvider>
    </AuthProvider>
  )
}

export default App
